import Chart from 'chart.js/auto';
export function drawChart(canvas,rounds,points,scores) {
    var ctx = canvas[0].getContext('2d');
    ctx.height = 150;

    let roundsArray = [];
    if (typeof rounds === 'number') {
        for (let i = 0; i < rounds; i++) {
            roundsArray.push(i)
        }
    } else {
        roundsArray = rounds;
    }
    return new Chart(ctx, {
        type: 'line',
        data: {
            labels: roundsArray,
            datasets: [{
                type: "bar",
                label: 'Geworfen',
                data: scores,
                backgroundColor: [
                    'hsl(345, 83%, 61%)',
                ],
                borderColor: [
                    'hsl(345, 83%, 41%)',
                ],
                borderWidth: 3,
                pointBorderWidth: 3,
                pointRadius: 7,
                pointHoverRadius: 7,
                barPercentage: 0.5,
                order: 2
            },
            {
                label: 'Punkte',
                data: points,
                backgroundColor: [
                    'hsl(204, 99%, 61%)'
                ],
                borderColor: [
                    'hsl(204, 99%, 36%)'
                ],
                borderWidth: 2,
                pointBorderWidth: 3,
                pointRadius: 8,
                pointHoverRadius: 9,
                pointStyle: 'rect',
                order: 1
            }]
        },
        options: {
            maintainAspectRatio: false,
            scales: {
                y: {
                    beginAtZero: true
                },
                x: {
                    title: {
                        text: "Runde",
                        display: true
                    }
                }
            }
        }
    });
}
